module.exports = __webpack_public_path__ + "img/Haefele_menu11.5d9cc8fd.png";